import { makeLMStyles } from "@launchmetrics/lm-ui";


export const useStyles = makeLMStyles(() => ({
	reportManager: {
		backgroundColor: '#f6f3f3',
		paddingTop: 'spacing-32',
		minHeight: '100%',
		paddingBottom: 'spacing-32'
	},
	reportManagerMainHeader: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	reportManagerTableContainer: {
		display: 'flex',
		flexDirection: 'column',
		padding: 'spacing-24',
		backgroundColor: 'white',
		borderBottomLeftRadius: 'radius8',
		borderBottomRightRadius: 'radius8'
	},
	reportManagerTable: {
		tableLayout: 'fixed',
		width: '100%'
	},
	reportManagerPaginationContainer: {
		backgroundColor: 'white',
		marginTop: 'spacing-24',
		paddingTop: 'spacing-24',
		paddingX: 'spacing-24',
		borderTopLeftRadius: 'radius8',
		borderTopRightRadius: 'radius8'
	},
	totalReports: {
		fontWeight: 'semibold'
	},
	tableHeaders: {
		fontWeight: 'bold'
	},
	cellReportName: {
		'&:hover': {
			textDecoration: 'underline',
			cursor: 'pointer'
		}
	},
	tableCells: {
		paddingBottom: 0,
		paddingTop: 0,
		paddingY: 'spacing-16'
	},
	checkBoxContainer: {
		display: 'flex',
		alignItems: 'center'
	},
	actionsContainer: {
		display: 'inline-flex',
		alignItems: 'center',
		paddingBottom: 'spacing-16',
		height: 40
	},
	actionDivider: {
		marginLeft: 'spacing-12',
		marginRight: 'spacing-4'
	},
	deleteIcon: {
		color: 'icon.danger'
	},
	noReportsContainer: {
		display: 'flex',
		flexDirection: 'column',
		padding: '64px 24px 64px 24px',
		backgroundColor: 'white',
		borderRadius: 'radius8',
		marginTop: 'spacing-24',
		alignItems: 'center',
		width: '100%'
	},
	noReportsTextContainer: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
		paddingTop: 'spacing-16'
	}
}));
